import config from './config';

const API = config.TUUTUUM_BACKEND_PUBLIC_API + "/v1";

async function get_data_by_token(token, no_sms) {
    let data;
    try {
		let URL = API + "/?token=" + token;
		if (no_sms) {
			URL += "&no_sms=1";
		}
		let response = await fetch(URL , {
			headers: {
			    'content-type': 'application/json',
			},
			method: `GET`,
			mode: `cors`
		    });
		if (!response.ok) {
		    const data = await response.json();
		    if(data?.status !== undefined) {
				return {
				    success: false,
				    msg: data.msg
				};
		    } else {
				throw("Invalid JSON data from server!");
	    	}
		}
		const response_data = await response.json();
		return {
		    success: true,
		    msg: response_data.msg,
		    data: response_data.data
		}
    } catch(err) {
		const msg = "fetch exception: " + err;
		console.log(msg);
		throw(msg);
    }
}

async function send_location_data(token, scan_id, loc, no_sms) {
    let data;
    try {
		let URL = API + "?token=" + token;
		if (no_sms) {
			URL += "&no_sms=1";
		}
		let response = await fetch(URL , {
			headers: {
			    'content-type': 'application/json',
			},
			method: `POST`,
			mode: `cors`,
			body: JSON.stringify({
					"scan_id": scan_id,
					"loc": loc
					}),
		    });
		if (!response.ok) {
		    const data = await response.json();
		    if(data?.status !== undefined) {
				return {
				    success: false,
				    msg: data.msg
				};
		    } else {
				throw("Invalid JSON data from server!");
	    	}
		}
		const response_data = await response.json();
		return {
		    success: true,
		    msg: response_data.msg,
		    data: response_data.data
		}
    } catch(err) {
		const msg = "fetch exception: " + err;
		console.log(msg);
		throw(msg);
    }
}

export {
	get_data_by_token,
	send_location_data
};
